/* eslint-disable func-names */
/* eslint-disable max-params */
import { ApiResponse } from "@axl-dev/school-sdk";
import { notification } from "antd";
import { ArgsProps } from "antd/lib/notification";
import { useCallback } from "react";

import { ErrorCode } from "../enums/error-code";

import { useLoc } from "./useLoc";

export const useNotifier = function () {
  const loc = useLoc();

  const notify = useCallback(
    function (
      result: ApiResponse<unknown>,
      success?: React.ReactNode,
      successOpts?: Omit<ArgsProps, "message">,
      errorOpts?: ArgsProps,
    ) {
      if (result.success) {
        if (success) {
          notification.open({
            duration: 2,
            message: success,
            type: successOpts?.type ?? "success",
            ...successOpts,
          });
        }

        return;
      }

      if (result.errors.length > 0) {
        result.errors.forEach((e) =>
          notification.error({
            duration: 2,
            message: e.message ?? loc.word(`Error${ErrorCode[e.code]}`),
            ...errorOpts,
          }),
        );

        return;
      }

      notification.error({
        duration: 2,
        message: loc.word("Error occured"),
        ...errorOpts,
      });
    },
    [loc],
  );

  return [notify] as const;
};

export default useNotifier;
